'use client'
import React, { useRef, useState } from 'react'
// import { useSubscription } from '@apollo/client'
import ScorecardTable from '@/shared/components/match/scorecardTable'
import FallWickets from '@/shared/components/match/fallWickets'
import BowlerDataRow from '@/shared/components/match/scorecardTable/BowlerDataRow'
import ThemeTable from '../../themeTable'
import { BowlerDataRowType } from '../types'
import { useSubscription } from '@apollo/client'
import { FULL_SCOREBOARD } from '@/graphql/match/match.subscription'
import NoData from '../../noData'
import scorecardVector from '../../../../assets/images/error-images/scorecard.svg'

type pagePropsType = {
  data?: any
  squad?: {
    bPlaying11: false
    iPlayerId: string
    oTeam: {
      sAbbr: string
      sTitle: string
      _id: string
      __typename: string
    }
    sName: string
    sRoleStr: string
    __typename: string
  }[]
  matchDetail: any
}

const MatchDetailScorecard = ({ data, matchDetail }: pagePropsType) => {
  const [fullScoreBoard, setFullScoreBoard] = useState(data?.fetchLiveInningsData)
  const isT100 = matchDetail?.oFormat?.sValue?.includes('t100')
  let labels: string[]
  if (isT100) {
    labels = ['Bowler', 'B', 'M', 'R', 'W', 'NB', 'WD', 'Eco']
  } else {
    labels = ['Bowler', 'Ov', 'M', 'R', 'W', 'NB', 'WD', 'Eco']
  }

  const table = useRef({
    sOvers: 'Ov',
    nMaidens: 'M',
    nRunsConceded: 'R',
    nWickets: 'W',
    nNoBalls: 'NB',
    nWides: 'WD',
    sEcon: 'Eco'
  })
  const fullSquad = data?.listMatchSquad
  const [team, setTeam] = useState(fullScoreBoard?.length - 1)

  useSubscription(FULL_SCOREBOARD, {
    skip: true,
    variables: { input: { iMatchId: matchDetail?._id, nInningNumber: matchDetail?.nLatestInningNumber } },
    onData: ({ data: subscriptionData }) => {
      const match = subscriptionData?.data?.fetchLiveInningsData
      if (match) {
        setFullScoreBoard(
          data?.fetchLiveInningsData?.map((item: any) => {
            if (item.nInningNumber === match?.nInningNumber) {
              return match
            }
            return item
          })
        )
      }
    }
  })
  return (
    <div className='container p-0 sm:pl-0'>
      {fullScoreBoard?.length === 0 ? (
        <NoData imagePath={scorecardVector} />
      ) : (
        <section className={``}>
          <div className='flex gap-4 justify-start mt-4 mb-6 flex-nowrap whitespace-nowrap overflow-x-auto pr-4'>
            {fullScoreBoard?.map((data: any, i: number) => {
              return (
                <div
                  key={`${data?.sShortName}-${i}`}
                  className={`${
                    team !== i ? 'bg-theme text-textDselected cursor-pointer' : '!bg-buttonBg text-white cursor-pointer font-bold'
                  } text-center select-none px-3 py-[5px] text-sm sm:text-base rounded-lg dark:bg-transparent bg-white w-fit border border-tabBorder font-medium flex-shrink-0`}
                  onClick={() => setTeam(i)}
                >
                  {data?.sShortName}
                </div>
              )
            })}
          </div>
          {fullScoreBoard?.map((data: any, i: number) => {
            if (team === i) {
              return (
                <React.Fragment key={i}>
                  <ScorecardTable data={data} fullSquad={fullSquad} matchDetail={matchDetail} />
                  {data?.aBowlers?.length > 0 && (
                    <div className={`mb-6 md:mx-0`}>
                      <ThemeTable labels={labels} className='!rounded-none md:!rounded-xl' isBordered={true}>
                        {data?.aBowlers?.map((bowler: BowlerDataRowType['bowler'], index: number) => {
                          return <BowlerDataRow key={`${bowler?.oBowler?.sFullName}-${index}`} bowler={bowler} table={table.current} />
                        })}
                      </ThemeTable>
                    </div>
                  )}
                  {data?.aFOWs?.length > 0 && <FallWickets data={data} isT100={isT100} />}
                </React.Fragment>
              )
            } else {
              return null
            }
          })}
        </section>
      )}
    </div>
  )
}

export default MatchDetailScorecard
